// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavbarBody__wrapper___1XAYk","label":"NavbarBody__label___n_4XV","sublabel":"NavbarBody__sublabel___1fqlE"};